import axios from 'axios';

const resource = '/portaltransparencia-api/api/obras';

export const findOneObra = (entidade, exercicioObra, idOrdemServico) => {
  return axios.get(
    `${resource}?entidade=${entidade}&exercicioObra=${exercicioObra}&idOrdemServico=${idOrdemServico}`
  );
};
